import { ISO_2022_THEMES } from './calculationEngine';

// Curated reference links per ISO/IEC 27001:2022 Annex A theme.
const THEME_RESOURCES = {
  organizational: [
    { title: 'ISO/IEC 27002:2022 — Information security controls', url: 'https://www.iso.org/standard/75652.html' },
    { title: 'NIST SP 800-53 Rev. 5', url: 'https://csrc.nist.gov/publications/detail/sp/800-53/rev-5/final' },
  ],
  people: [
    { title: 'SANS Security Awareness Training', url: 'https://www.sans.org/security-awareness-training' },
    { title: 'ENISA Cybersecurity Education', url: 'https://www.enisa.europa.eu/topics/cybersecurity-education' },
  ],
  physical: [
    { title: 'CIS Controls — Enterprise Asset Management', url: 'https://www.cisecurity.org/controls/inventory-and-control-of-enterprise-assets' },
    { title: 'ASIS International', url: 'https://www.asisonline.org/' },
  ],
  technological: [
    { title: 'OWASP Secure Coding Practices', url: 'https://owasp.org/www-project-secure-coding-practices-quick-reference-guide/' },
    { title: 'CIS Controls v8', url: 'https://www.cisecurity.org/controls/v8' },
  ],
};

// The 4 ISO/IEC 27001:2022 Annex A themes for the Guidance / Knowledge Base.
// Names, descriptions, control-group labels and maturity tips are localized via
// i18n (sections `iso2022` and `guidance.themes`); structural data (code, control
// count, control groups, new-control flags) comes from ISO_2022_THEMES so the
// Guidance page stays perfectly consistent with the calculator's advanced
// assessment.
export const ISO_2022_GUIDANCE = ISO_2022_THEMES.map(theme => ({
  ...theme,
  resources: THEME_RESOURCES[theme.id] || [],
}));
